export default __webpack_public_path__ + "static/media/crab-smart-chain.0b76fa7b.svg";